export default __webpack_public_path__ + "static/Wishlist on Steam-888368bf4de3305316f92bb01f997a20.png";